import { useEffect } from "react"
import { connect } from "react-redux"
import BVAInput from "../../../../components/BVAInput/BVAInput";
import CurrencyFormatter from "currency-formatter";
import {
  addCustomFieldToPurchaseAcquisitionExpenses,
  generatePurchaserAcquisitionExpenses, updateCustomFieldOnProceedsWorksheet,
  updatePurchaserAcquisitionExpenses,
} from "../../../../store/modules/acquisitionExpenses/actions";
import BVAButton from "../../../../components/BVAButton/BVAButton";
import DeleteIcon from "@mui/icons-material/Delete";


const addItemContainerWidth = "calc(784px - 48px - 1rem)";

function StockPurchaserAcquisitionExpenses({
  stockPurchaserAcquisitionExpenses,
  dispatchUpdatePurchaserAcquisitionExpenses,
  dispatchGeneratePurchaserAcquisitionExpenses,
  dispatchAddCustomFieldToStockPurchaseAcquisitionExpenses,
  dispatchUpdateCustomFieldOnStockPurchaseAcquisitionExpenses
}) {
  // Mounted
  useEffect(() => {
    dispatchGeneratePurchaserAcquisitionExpenses()
  }, [])

  // Methods
  const handleStockPurchaserAcquisitionExpensesOnChange = (groupKey, key, value) => {
    dispatchUpdatePurchaserAcquisitionExpenses({
      [groupKey]: {
        [key]: CurrencyFormatter.unformat(value, { code: "USD" })
      }
    })
  }

  const handleCustomFieldOnCreation = (section) => {
    dispatchAddCustomFieldToStockPurchaseAcquisitionExpenses({ section })
  }

  const handleCustomFieldValueOnUpdate = ({ section, index, name, value }) => {
    const customFields = stockPurchaserAcquisitionExpenses[section].customFields?.map((customField, _index) => {
      if (_index === index) {
        const _customField = { ...customField }
        if (name || name === "") _customField.name = name
        if (value || value === 0 || value === "") _customField.value = CurrencyFormatter.unformat(value, { code: "USD" })

        return _customField
      }

      return customField
    })

    dispatchUpdateCustomFieldOnStockPurchaseAcquisitionExpenses({ section, customFields })
  }

  const handleDeleteCustomField = ({ section, index }) => {
    const customFields = stockPurchaserAcquisitionExpenses[section].customFields.filter((customField, _index) => {
      if (_index === index) return false

      return true
    })

    dispatchUpdateCustomFieldOnStockPurchaseAcquisitionExpenses({ section, customFields })
  }


  return (
    <div>
      <div className="mt-10">
        <h2 className="text-lg font-semibold">Due Diligence and Transaction Expenses</h2>
        <div className="mt-4">
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">
                Attorney Fees
              </label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.generalAcquisition?.attorneyFees}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("generalAcquisition", "attorneyFees", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Escrow Service Fees</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.generalAcquisition?.escrowServiceFees}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("generalAcquisition", "escrowServiceFees", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Appraisal Fees</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.generalAcquisition?.appraisalFees}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("generalAcquisition", "appraisalFees", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Accountant's Fees</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.generalAcquisition?.accountantsFees}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("generalAcquisition", "accountantsFees", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Franchise License Agreement Transfer Fees</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.generalAcquisition?.franchiseLicenseAgreementTransferFees}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("generalAcquisition", "franchiseLicenseAgreementTransferFees", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Business Brokerage Fees</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.generalAcquisition?.businessBrokerageFees}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("generalAcquisition", "businessBrokerageFees", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Filings & Recording Fees</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.generalAcquisition?.fillingsRecordingFees}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("generalAcquisition", "fillingsRecordingFees", value)}/>
            </div>
          </div>
          {stockPurchaserAcquisitionExpenses?.generalAcquisition?.customFields?.map((customField, index) => (
            <div className="flex mb-2 items-center">
              <div className="w-96 flex items-center pr-2">
                <BVAInput
                  value={customField?.name}
                  placeholder="Item name"
                  type="text"
                  size="small"
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "generalAcquisition",
                    index,
                    name: value
                  })}/>
              </div>
              <div className="w-40 flex items-center pr-2" />
              <div className="flex items-center -ml-5">
                <BVAInput
                  size="small"
                  startAdornment
                  startAdornmentLabel="$"
                  value={customField?.value}
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "generalAcquisition",
                    index,
                    value
                  })} />
                <div className="ml-2">
                  <BVAButton
                    shape="circle"
                    iconButton
                    icon={{ url: DeleteIcon }}
                    onClick={() => handleDeleteCustomField({ section: "generalAcquisition", index })} />
                </div>
              </div>
            </div>
          ))}
          <div className="mt-10 flex justify-center border rounded p-5" style={{ maxWidth: addItemContainerWidth }}>
            <BVAButton
              kind="primary-outlined"
              slimHeight
              onClick={() => handleCustomFieldOnCreation("generalAcquisition")}>
              Add Item
            </BVAButton>
          </div>
          <div className="flex items-center bg-neutral-100 p-5 rounded-lg mt-4" style={{ maxWidth: addItemContainerWidth }}>
            <div className="w-96 flex justify-center flex-col pr-2">
              <label className="whitespace-nowrap font-semibold">
                Total Closing Costs to Be Paid by Purchaser
              </label>
            </div>
            <div className="w-60 flex items-center pr-2 -ml-10" />
            <div className="flex items-center pr-10">
              <label className="whitespace-nowrap">
                {stockPurchaserAcquisitionExpenses?.generalAcquisition?.totalClosingCostsToBePaidByPurchaserFormatted}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <h2 className="text-lg font-semibold">General Business Expenses</h2>
        <div className="mt-4">
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Franchisor Training Expenses</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees?.franchisorTrainingExpenses}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("acquisitionLicensesTaxesPermitsAndFees", "franchisorTrainingExpenses", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">City, County & State Business Licenses and Permits</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees?.cityCountyAndStateBusinessLicensesAndPermits}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("acquisitionLicensesTaxesPermitsAndFees", "cityCountyAndStateBusinessLicensesAndPermits", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Loan Fees for 3rd Party Purchase Loan</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees?.loanFeesForThirdPartyPurchaseLoan}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("acquisitionLicensesTaxesPermitsAndFees", "loanFeesForThirdPartyPurchaseLoan", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Travel Expenses</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees?.travelExpenses}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("acquisitionLicensesTaxesPermitsAndFees", "travelExpenses", value)}/>
            </div>
          </div>

          {stockPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees?.customFields?.map((customField, index) => (
            <div className="flex mb-2 items-center">
              <div className="w-96 flex items-center pr-2">
                <BVAInput
                  value={customField?.name}
                  placeholder="Item name"
                  type="text"
                  size="small"
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "acquisitionLicensesTaxesPermitsAndFees",
                    index,
                    name: value
                  })}/>
              </div>
              <div className="w-40 flex items-center pr-2" />
              <div className="flex items-center -ml-5">
                <BVAInput
                  size="small"
                  startAdornment
                  startAdornmentLabel="$"
                  value={customField?.value}
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "acquisitionLicensesTaxesPermitsAndFees",
                    index,
                    value
                  })} />
                <div className="ml-2">
                  <BVAButton
                    shape="circle"
                    iconButton
                    icon={{ url: DeleteIcon }}
                    onClick={() => handleDeleteCustomField({ section: "acquisitionLicensesTaxesPermitsAndFees", index })} />
                </div>
              </div>
            </div>
          ))}
          <div className="mt-10 flex justify-center border rounded p-5" style={{ maxWidth: addItemContainerWidth }}>
            <BVAButton
              kind="primary-outlined"
              slimHeight
              onClick={() => handleCustomFieldOnCreation("acquisitionLicensesTaxesPermitsAndFees")}>
              Add Item
            </BVAButton>
          </div>

          <div className="flex items-center bg-neutral-100 p-5 rounded-lg mt-4" style={{ maxWidth: addItemContainerWidth }}>
            <div className="w-96 flex justify-center flex-col pr-2">
              <label className="whitespace-nowrap font-semibold">
                Total Closing Costs to Be Paid by Purchaser
              </label>
            </div>
            <div className="w-60 flex items-center pr-2 -ml-10" />
            <div className="flex items-center pr-10">
              <label className="whitespace-nowrap">
                {stockPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees?.totalAdditionalPurchaserCashPayoutRequirementsFormatted}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <h2 className="text-lg font-semibold">(Pre-Paid) Assets Needed</h2>
        <div className="mt-4">
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">
                Lease Deposit
              </label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.prePaidAssetsNeeded?.leaseDeposit}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("prePaidAssetsNeeded", "leaseDeposit", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Utility Company Deposit</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.prePaidAssetsNeeded?.utilityCompanyDeposit}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("prePaidAssetsNeeded", "utilityCompanyDeposit", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Product Liability & Comprehensive Insurance Prepayment</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.prePaidAssetsNeeded?.productLiabilityAndComprehensiveInsurancePrepayment}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("prePaidAssetsNeeded", "productLiabilityAndComprehensiveInsurancePrepayment", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Workers Compensation Insurance Prepayment</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.prePaidAssetsNeeded?.workersCompensationInsurancePrepayment}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("prePaidAssetsNeeded", "workersCompensationInsurancePrepayment", value)}/>
            </div>
          </div>

          {stockPurchaserAcquisitionExpenses?.prePaidAssetsNeeded?.customFields?.map((customField, index) => (
            <div className="flex mb-2 items-center">
              <div className="w-96 flex items-center pr-2">
                <BVAInput
                  value={customField?.name}
                  placeholder="Item name"
                  type="text"
                  size="small"
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "prePaidAssetsNeeded",
                    index,
                    name: value
                  })}/>
              </div>
              <div className="w-40 flex items-center pr-2" />
              <div className="flex items-center -ml-5">
                <BVAInput
                  size="small"
                  startAdornment
                  startAdornmentLabel="$"
                  value={customField?.value}
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "prePaidAssetsNeeded",
                    index,
                    value
                  })} />
                <div className="ml-2">
                  <BVAButton
                    shape="circle"
                    iconButton
                    icon={{ url: DeleteIcon }}
                    onClick={() => handleDeleteCustomField({ section: "prePaidAssetsNeeded", index })} />
                </div>
              </div>
            </div>
          ))}
          <div className="mt-10 flex justify-center border rounded p-5" style={{ maxWidth: addItemContainerWidth }}>
            <BVAButton
              kind="primary-outlined"
              slimHeight
              onClick={() => handleCustomFieldOnCreation("prePaidAssetsNeeded")}>
              Add Item
            </BVAButton>
          </div>

          <div className="flex items-center bg-neutral-100 p-5 rounded-lg mt-4" style={{ maxWidth: addItemContainerWidth }}>
            <div className="w-96 flex justify-center flex-col pr-2">
              <label className="whitespace-nowrap font-semibold">
                Total Closing Costs to Be Paid by Purchaser
              </label>
            </div>
            <div className="w-60 flex items-center pr-2 -ml-10" />
            <div className="flex items-center pr-10">
              <label className="whitespace-nowrap">
                {stockPurchaserAcquisitionExpenses?.prePaidAssetsNeeded?.totalAdditionalPurchaserCashPayoutForAssetsFormatted}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <h2 className="text-lg font-semibold">Working Capital Needed at Closing</h2>
        <div className="mt-4">
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Operating Cash</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.workingCapitalNeededAtClosing?.operatingCash}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("workingCapitalNeededAtClosing", "operatingCash", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Accounts Receivable</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.workingCapitalNeededAtClosing?.accountsReceivable}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("workingCapitalNeededAtClosing", "accountsReceivable", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Inventory</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={stockPurchaserAcquisitionExpenses?.workingCapitalNeededAtClosing?.inventory}
                onChange={(value) => handleStockPurchaserAcquisitionExpensesOnChange("workingCapitalNeededAtClosing", "inventory", value)}/>
            </div>
          </div>

          {stockPurchaserAcquisitionExpenses?.workingCapitalNeededAtClosing?.customFields?.map((customField, index) => (
            <div key={index} className="flex mb-2 items-center">
              <div className="w-96 flex items-center pr-2">
                <BVAInput
                  value={customField?.name}
                  placeholder="Item name"
                  type="text"
                  size="small"
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "workingCapitalNeededAtClosing",
                    index,
                    name: value
                  })}/>
              </div>
              <div className="w-40 flex items-center pr-2" />
              <div className="flex items-center -ml-5">
                <BVAInput
                  size="small"
                  startAdornment
                  startAdornmentLabel="$"
                  value={customField?.value}
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "workingCapitalNeededAtClosing",
                    index,
                    value
                  })} />
                <div className="ml-2">
                  <BVAButton
                    shape="circle"
                    iconButton
                    icon={{ url: DeleteIcon }}
                    onClick={() => handleDeleteCustomField({ section: "workingCapitalNeededAtClosing", index })} />
                </div>
              </div>
            </div>
          ))}
          <div className="mt-10 flex justify-center border rounded p-5" style={{ maxWidth: addItemContainerWidth }}>
            <BVAButton
              kind="primary-outlined"
              slimHeight
              onClick={() => handleCustomFieldOnCreation("workingCapitalNeededAtClosing")}>
              Add Item
            </BVAButton>
          </div>

          <div className="flex items-center bg-neutral-100 p-5 rounded-lg mt-4" style={{ maxWidth: addItemContainerWidth }}>
            <div className="w-96 flex justify-center flex-col pr-2">
              <label className="whitespace-nowrap font-semibold">
                Total Cash Payment for All Additional Assets to Be Purchased
              </label>
            </div>
            <div className="w-60 flex items-center pr-2 -ml-10" />
            <div className="flex items-center pr-10">
              <label className="whitespace-nowrap">
                {stockPurchaserAcquisitionExpenses?.workingCapitalNeededAtClosing?.totalCashPaymentForAllAdditionalAssetsToBePurchasedFormatted}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5">
        <div className="flex items-center mb-4 bg-neutral-200 p-5 rounded-lg" style={{ maxWidth: addItemContainerWidth }}>
          <div className="w-96 flex items-center pr-2">
            <label className="whitespace-nowrap font-semibold">Additional Capital Needed at Closing</label>
          </div>
          <div className="w-60 flex items-center pr-2" />

          <div className="flex items-center pr-10 -ml-10">
            <label className="whitespace-nowrap font-semibold">
              {stockPurchaserAcquisitionExpenses?.additionalCapitalNeededAtClosingFormatted}
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  stockPurchaserAcquisitionExpenses: state.acquisitionExpenses.stockPurchaserAcquisitionExpenses
})

const mapDispatchToProps = (dispatch) => ({
  dispatchGeneratePurchaserAcquisitionExpenses() {
    dispatch(generatePurchaserAcquisitionExpenses({
      purchaseAcquisitionExpensesType: "stock"
    }))
  },

  dispatchUpdatePurchaserAcquisitionExpenses({
    generalAcquisition,
    acquisitionLicensesTaxesPermitsAndFees,
    prePaidAssetsNeeded,
    workingCapitalNeededAtClosing
  }) {
    dispatch(updatePurchaserAcquisitionExpenses({
      purchaserAcquisitionExpensesType: "stock"
    }, {
      generalAcquisition,
      acquisitionLicensesTaxesPermitsAndFees,
      prePaidAssetsNeeded,
      workingCapitalNeededAtClosing
    }))
  },

  dispatchAddCustomFieldToStockPurchaseAcquisitionExpenses({ section }) {
    dispatch(addCustomFieldToPurchaseAcquisitionExpenses({
      purchaserAcquisitionExpensesType: "stock"
    }, {
      section
    }))
  },

  dispatchUpdateCustomFieldOnStockPurchaseAcquisitionExpenses({ customFields, section }) {
    dispatch(updateCustomFieldOnProceedsWorksheet({
      purchaserAcquisitionExpensesType: "stock"
    }, {
      section,
      customFields
    }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(StockPurchaserAcquisitionExpenses)